// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-signup-page {
  position: fixed;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  inset: 0;
  box-sizing: border-box;
  background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);
}

.new-signup-page-inner {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding-top: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-top));
  padding-right: max(0.75rem, env(safe-area-inset-right));
  padding-bottom: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-bottom));
  padding-left: max(0.75rem, env(safe-area-inset-left));
}

.new-signup-page .page_logo {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.new-signup-page .page_logo a {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

/* Match sign-in: small wordmark; dark PNG reads better with subtle lift on gradient */
.new-signup-page .page_logo img {
  width: auto;
  max-width: 150px;
  height: auto;
  display: block;
  flex: 0 0 auto;
  min-width: 0;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 1px rgba(255, 255, 255, 0.25));
}

.new-signup-container {
  width: calc(100% - 3rem);
  max-width: 600px;
  background-color: #fff;
  box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
  border-radius: 1rem;
  padding: 2rem;
  justify-self: center;
  margin-bottom: 0;
}

.signup-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.signup-header h1 {
  margin: 0 0 0.5rem;
  color: rgb(5, 27, 44);
  font-size: 1.75rem;
  font-weight: 600;
}

.signup-header p {
  margin: 0;
  color: rgb(66, 77, 87);
  font-size: 1rem;
}

/* Progress Steps */
.progress-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  padding: 0 1rem;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.step.active .step-number {
  background-color: rgb(67, 70, 206);
  color: #fff;
}

.step.completed .step-number {
  background-color: #4caf50;
  color: #fff;
}

.step span {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
}

.step.active span {
  color: rgb(67, 70, 206);
}

.step.completed span {
  color: #4caf50;
}

.step-line {
  flex: 1 1;
  height: 2px;
  background-color: #e0e0e0;
  margin: 0 0.5rem;
  margin-bottom: 1.5rem;
  max-width: 60px;
}

/* Form Steps */
.form-step {
  margin-bottom: 1.5rem;
}

.form-step h2 {
  margin: 0 0 0.5rem;
  color: rgb(5, 27, 44);
  font-size: 1.25rem;
  font-weight: 600;
}

.step-description {
  margin: 0 0 1.5rem;
  color: rgb(66, 77, 87);
  font-size: 0.875rem;
}

.form-row {
  margin-bottom: 1rem;
}

.form-row.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgb(5, 27, 44);
}

.required {
  color: #e53935;
}

.form-group input,
.form-group select {
  height: 2.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgb(203, 209, 215);
  border-radius: 0.25rem;
  font-size: 1rem;
  color: rgb(5, 27, 44);
  background: #fff;
  transition: border-color 0.2s ease;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: rgb(67, 70, 206);
}

.form-group input.error,
.form-group select.error {
  border-color: #e53935;
}

.form-group input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.error-text {
  color: #e53935;
  font-size: 0.75rem;
}

/* Password Input */
.password-input-wrapper {
  position: relative;
  display: flex;
}

.password-input-wrapper input {
  width: 100%;
  padding-right: 2.5rem;
}

.password-toggle {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  cursor: pointer;
  opacity: 0.7;
}

.password-toggle:hover {
  opacity: 1;
}

/* Checkbox Group */
.checkbox-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.checkbox-group input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.checkbox-group label {
  font-size: 0.875rem;
  color: rgb(66, 77, 87);
  cursor: pointer;
}

/* Terms Checkbox */
.terms-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1rem;
}

.terms-checkbox input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  margin-top: 0.125rem;
  cursor: pointer;
}

.terms-checkbox label {
  font-size: 0.875rem;
  color: rgb(66, 77, 87);
  line-height: 1.4;
}

.terms-checkbox label a {
  color: rgb(67, 70, 206);
  text-decoration: none;
}

.terms-checkbox label a:hover {
  text-decoration: underline;
}

/* Channel Options */
.channel-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 0.5rem;
}

.channel-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 0.75rem;
  min-height: 120px;
}

.channel-option:hover {
  border-color: rgb(67, 70, 206);
  background-color: rgba(67, 70, 206, 0.05);
}

.channel-option.selected {
  border-color: rgb(67, 70, 206);
  background-color: rgba(67, 70, 206, 0.1);
}

.channel-option span {
  font-size: 0.75rem;
  color: rgb(5, 27, 44);
  text-align: center;
  font-weight: 500;
}

/* Navigation Buttons */
.form-navigation {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

/* Matches the modern 2FA / Sign in buttons: rounded, no border, soft indigo glow. */
.btn-back,
.btn-next,
.btn-submit {
  flex: 1 1;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.btn-back {
  background-color: #fff;
  border: 1px solid rgb(226, 230, 239);
  color: rgb(66, 77, 87);
}

.btn-back:hover {
  background-color: #f5f6fa;
  border-color: rgb(203, 209, 215);
}

.btn-next,
.btn-submit {
  background-color: rgb(67, 70, 206);
  border: none;
  color: #fff;
  box-shadow: 0 4px 16px rgba(67, 70, 206, 0.35);
}

.btn-next:hover:not(:disabled),
.btn-submit:hover:not(:disabled) {
  background-color: rgb(67, 70, 206);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(67, 70, 206, 0.45);
}

.btn-submit:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
  box-shadow: none;
}

/* Thank You Page */
.thank-you-container {
  width: calc(100% - 3rem);
  max-width: 500px;
  background-color: #fff;
  box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
  border-radius: 1rem;
  padding: 3rem 2rem;
  justify-self: center;
  text-align: center;
}

.thank-you-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #4caf50;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
}

.thank-you-container h1 {
  margin: 0 0 1rem;
  color: rgb(5, 27, 44);
  font-size: 1.75rem;
  font-weight: 600;
}

.thank-you-message {
  margin: 0 0 0.5rem;
  color: rgb(66, 77, 87);
  font-size: 1rem;
}

.thank-you-submessage {
  margin: 0 0 2rem;
  color: rgb(100, 110, 120);
  font-size: 0.875rem;
  line-height: 1.5;
}

.thank-you-info {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  font-size: 0.875rem;
  color: rgb(66, 77, 87);
}

.info-icon {
  font-size: 1.25rem;
}

.back-to-login-btn {
  display: inline-block;
  padding: 0.75rem 2rem;
  background-color: rgb(67, 70, 206);
  color: #fff;
  border-radius: 0.25rem;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.back-to-login-btn:hover {
  background-color: rgb(58, 61, 179);
  color: #fff;
}

/* Responsive */
@media (max-width: 600px) {
  .form-row.two-columns {
    grid-template-columns: 1fr;
  }

  .channel-options {
    grid-template-columns: 1fr;
  }

  .channel-option {
    flex-direction: row;
    min-height: auto;
    padding: 1rem;
  }

  .progress-steps {
    padding: 0;
  }

  .step span {
    display: none;
  }

  .step-line {
    margin-bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/NewUserSignup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,QAAQ;EACR,sBAAsB;EACtB,4GAA4G;AAC9G;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kEAAkE;EAClE,uDAAuD;EACvD,wEAAwE;EACxE,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sFAAsF;AACtF;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,YAAY;EACZ,iGAAiG;AACnG;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0FAA0F;EAC1F,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;;;EAGE,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,8CAA8C;AAChD;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0FAA0F;EAC1F,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kCAAkC;EAClC,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".new-signup-page {\n  position: fixed;\n  overflow-x: auto;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  inset: 0;\n  box-sizing: border-box;\n  background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);\n}\n\n.new-signup-page-inner {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n  padding-top: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-top));\n  padding-right: max(0.75rem, env(safe-area-inset-right));\n  padding-bottom: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-bottom));\n  padding-left: max(0.75rem, env(safe-area-inset-left));\n}\n\n.new-signup-page .page_logo {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.new-signup-page .page_logo a {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Match sign-in: small wordmark; dark PNG reads better with subtle lift on gradient */\n.new-signup-page .page_logo img {\n  width: auto;\n  max-width: 150px;\n  height: auto;\n  display: block;\n  flex: 0 0 auto;\n  min-width: 0;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 1px rgba(255, 255, 255, 0.25));\n}\n\n.new-signup-container {\n  width: calc(100% - 3rem);\n  max-width: 600px;\n  background-color: #fff;\n  box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n  border-radius: 1rem;\n  padding: 2rem;\n  justify-self: center;\n  margin-bottom: 0;\n}\n\n.signup-header {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.signup-header h1 {\n  margin: 0 0 0.5rem;\n  color: rgb(5, 27, 44);\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n.signup-header p {\n  margin: 0;\n  color: rgb(66, 77, 87);\n  font-size: 1rem;\n}\n\n/* Progress Steps */\n.progress-steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2rem;\n  padding: 0 1rem;\n}\n\n.step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.step-number {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n}\n\n.step.active .step-number {\n  background-color: rgb(67, 70, 206);\n  color: #fff;\n}\n\n.step.completed .step-number {\n  background-color: #4caf50;\n  color: #fff;\n}\n\n.step span {\n  font-size: 0.75rem;\n  color: #666;\n  font-weight: 500;\n}\n\n.step.active span {\n  color: rgb(67, 70, 206);\n}\n\n.step.completed span {\n  color: #4caf50;\n}\n\n.step-line {\n  flex: 1;\n  height: 2px;\n  background-color: #e0e0e0;\n  margin: 0 0.5rem;\n  margin-bottom: 1.5rem;\n  max-width: 60px;\n}\n\n/* Form Steps */\n.form-step {\n  margin-bottom: 1.5rem;\n}\n\n.form-step h2 {\n  margin: 0 0 0.5rem;\n  color: rgb(5, 27, 44);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.step-description {\n  margin: 0 0 1.5rem;\n  color: rgb(66, 77, 87);\n  font-size: 0.875rem;\n}\n\n.form-row {\n  margin-bottom: 1rem;\n}\n\n.form-row.two-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: rgb(5, 27, 44);\n}\n\n.required {\n  color: #e53935;\n}\n\n.form-group input,\n.form-group select {\n  height: 2.5rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid rgb(203, 209, 215);\n  border-radius: 0.25rem;\n  font-size: 1rem;\n  color: rgb(5, 27, 44);\n  background: #fff;\n  transition: border-color 0.2s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: rgb(67, 70, 206);\n}\n\n.form-group input.error,\n.form-group select.error {\n  border-color: #e53935;\n}\n\n.form-group input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.error-text {\n  color: #e53935;\n  font-size: 0.75rem;\n}\n\n/* Password Input */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n}\n\n.password-input-wrapper input {\n  width: 100%;\n  padding-right: 2.5rem;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  opacity: 0.7;\n}\n\n.password-toggle:hover {\n  opacity: 1;\n}\n\n/* Checkbox Group */\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 1rem;\n  height: 1rem;\n  cursor: pointer;\n}\n\n.checkbox-group label {\n  font-size: 0.875rem;\n  color: rgb(66, 77, 87);\n  cursor: pointer;\n}\n\n/* Terms Checkbox */\n.terms-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.terms-checkbox input[type=\"checkbox\"] {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0.125rem;\n  cursor: pointer;\n}\n\n.terms-checkbox label {\n  font-size: 0.875rem;\n  color: rgb(66, 77, 87);\n  line-height: 1.4;\n}\n\n.terms-checkbox label a {\n  color: rgb(67, 70, 206);\n  text-decoration: none;\n}\n\n.terms-checkbox label a:hover {\n  text-decoration: underline;\n}\n\n/* Channel Options */\n.channel-options {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.channel-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: 0.75rem;\n  min-height: 120px;\n}\n\n.channel-option:hover {\n  border-color: rgb(67, 70, 206);\n  background-color: rgba(67, 70, 206, 0.05);\n}\n\n.channel-option.selected {\n  border-color: rgb(67, 70, 206);\n  background-color: rgba(67, 70, 206, 0.1);\n}\n\n.channel-option span {\n  font-size: 0.75rem;\n  color: rgb(5, 27, 44);\n  text-align: center;\n  font-weight: 500;\n}\n\n/* Navigation Buttons */\n.form-navigation {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n/* Matches the modern 2FA / Sign in buttons: rounded, no border, soft indigo glow. */\n.btn-back,\n.btn-next,\n.btn-submit {\n  flex: 1;\n  padding: 0.75rem 1.5rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.btn-back {\n  background-color: #fff;\n  border: 1px solid rgb(226, 230, 239);\n  color: rgb(66, 77, 87);\n}\n\n.btn-back:hover {\n  background-color: #f5f6fa;\n  border-color: rgb(203, 209, 215);\n}\n\n.btn-next,\n.btn-submit {\n  background-color: rgb(67, 70, 206);\n  border: none;\n  color: #fff;\n  box-shadow: 0 4px 16px rgba(67, 70, 206, 0.35);\n}\n\n.btn-next:hover:not(:disabled),\n.btn-submit:hover:not(:disabled) {\n  background-color: rgb(67, 70, 206);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(67, 70, 206, 0.45);\n}\n\n.btn-submit:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Thank You Page */\n.thank-you-container {\n  width: calc(100% - 3rem);\n  max-width: 500px;\n  background-color: #fff;\n  box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n  border-radius: 1rem;\n  padding: 3rem 2rem;\n  justify-self: center;\n  text-align: center;\n}\n\n.thank-you-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: #4caf50;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  font-size: 2rem;\n}\n\n.thank-you-container h1 {\n  margin: 0 0 1rem;\n  color: rgb(5, 27, 44);\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n.thank-you-message {\n  margin: 0 0 0.5rem;\n  color: rgb(66, 77, 87);\n  font-size: 1rem;\n}\n\n.thank-you-submessage {\n  margin: 0 0 2rem;\n  color: rgb(100, 110, 120);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.thank-you-info {\n  background-color: #f8f9fa;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  font-size: 0.875rem;\n  color: rgb(66, 77, 87);\n}\n\n.info-icon {\n  font-size: 1.25rem;\n}\n\n.back-to-login-btn {\n  display: inline-block;\n  padding: 0.75rem 2rem;\n  background-color: rgb(67, 70, 206);\n  color: #fff;\n  border-radius: 0.25rem;\n  text-decoration: none;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.back-to-login-btn:hover {\n  background-color: rgb(58, 61, 179);\n  color: #fff;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .form-row.two-columns {\n    grid-template-columns: 1fr;\n  }\n\n  .channel-options {\n    grid-template-columns: 1fr;\n  }\n\n  .channel-option {\n    flex-direction: row;\n    min-height: auto;\n    padding: 1rem;\n  }\n\n  .progress-steps {\n    padding: 0;\n  }\n\n  .step span {\n    display: none;\n  }\n\n  .step-line {\n    margin-bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
